import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withImageOptimizer } from 'Utils/Content';
import { SectionTitle } from 'Components/Titles';
import { SmartLink } from 'Components/SmartLink';
import FeatureImage from 'Components/FeatureImage';
import { WatchNowButton } from 'Components/WatchNowButton';
import { GetAppButton } from 'Components/FreeFormPanels/GetAppButton';
import { device } from 'device.js';
import { Markdown } from 'Components/Markdown';
import './ButtonCTA.css';

const getCtaComponent = (ctaText, screenName, confirmationScreen, upgradeConfirmationScreen, url) => {
  if (ctaText && screenName && (screenName === confirmationScreen || screenName === upgradeConfirmationScreen)) {
    return (
      <Fragment>
        <GetAppButton ctaText="Get the App" isMobile={device.mobile} />
        <WatchNowButton buttonText="Continue Home" isMobile={device.mobile} />
      </Fragment>
    );
  }
  if (ctaText) {
    return <SmartLink text={ctaText} linkUrl={url} className="ButtonCTALink" reload />;
  }
  return null;
};

export const ButtonCTAComponent = ({
  headline,
  description,
  ctaText,
  url,
  image,
  screenName,
  confirmationScreen,
  upgradeConfirmationScreen,
}) => {
  const defaultRenderer = {
    paragraph: ({ children }) => <span className="ButtonCTADescription">{children}</span>,
  };

  if (device.mobile) {
    return (
      <div className="ButtonCTA" data-testid="ButtonCTA">
        <div className="ButtonCTABackgroundContainer">
          <h3 className="MobileSectionTitle">{headline}</h3>
          <div className="MobileCTADescriptionContainer">
            Go mobile with Fox Nation. Our official app makes it easy to watch anywhere!
          </div>
        </div>
        {getCtaComponent(ctaText, screenName, confirmationScreen, upgradeConfirmationScreen, url)}
      </div>
    );
  }

  return (
    <div className="ButtonCTA" data-testid="ButtonCTA">
      <SectionTitle text={headline} align="center" />
      {description && (
        <Markdown className="ButtonCTADescriptionContainer" source={description} renderers={defaultRenderer} />
      )}
      {image && <FeatureImage url={url} src={withImageOptimizer(image)} srcSet="" />}
      {getCtaComponent(ctaText, screenName, confirmationScreen, url)}
    </div>
  );
};

const mapStateToProps = ({
  appConfig: {
    screens: { confirmationScreen, upgradeConfirmationScreen },
  },
}) => ({
  confirmationScreen,
  upgradeConfirmationScreen,
});

export const ButtonCTA = connect(mapStateToProps)(ButtonCTAComponent);
